export default __webpack_public_path__ + "c5730f2734cd87e603691a518a6c2284.png";